<h5 class="mb-0">
  <strong>{{ data.title }}</strong>
</h5>